/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Field_ReminderInputs */

const en_us2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Workout reminder`)
};

const pt_br2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete de treino`)
};

const es_419_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recordatorio de entrenamiento`)
};

const pt_pt2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lembrete de treino`)
};

const fr_fr2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rappel de séance`)
};

const de_de2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trainingserinnerung`)
};

const it_it2_search_field_reminder = /** @type {(inputs: Search_Field_ReminderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Promemoria allenamento`)
};

/**
* | output |
* | --- |
* | "Workout reminder" |
*
* @param {Search_Field_ReminderInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_field_reminder = /** @type {((inputs?: Search_Field_ReminderInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Field_ReminderInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_field_reminder(inputs)
	if (locale === "es-419") return es_419_search_field_reminder(inputs)
	if (locale === "pt-PT") return pt_pt2_search_field_reminder(inputs)
	if (locale === "fr-FR") return fr_fr2_search_field_reminder(inputs)
	if (locale === "de-DE") return de_de2_search_field_reminder(inputs)
	if (locale === "it-IT") return it_it2_search_field_reminder(inputs)
	return en_us2_search_field_reminder(inputs)
});
export { search_field_reminder as "search.field_reminder" }